'use client'

import styles from './Hero.module.scss'
import useProgressiveImg from '@/hooks/useProgressiveImg';

const Hero = ({className='', image = '', tagline = ''}) => {
  const [src, { blur }] = useProgressiveImg(image.replace("-lg", "-sm"), image);
  return (
    <div className={styles["hero"]}>
      {image && (
        <picture>
          <img
            src={image}
            style={{
              filter: blur ? "blur(10px)" : "none",
              transition: blur ? "none" : "filter 0.5s ease",
            }}
          />
        </picture>
      )}

      {tagline && <h3>{tagline}</h3>}
    </div>
  );
}

export default Hero
